export const engagementAppGroupIdStructuralTemplateCanvasTemplatesData =
  "/engagement/:app_group_id/structural_template/canvas_templates_data";
